<template>
  <div class="nav">
    <div class="nav-logo">
      <img src="@/assets/img/logo.png" alt="广东林业" class="logo" @click="goHomePage" />
    </div>

    <div class="nav-menu">
      <el-menu
        :default-active="activeIndex"
        mode="horizontal"
        :ellipsis="false"
        @select="handleSelect"
        class="el-menu-header"
      >
        <el-menu-item index="home">
          <router-link to="/home">首页</router-link>
         
        </el-menu-item>
        <el-menu-item index="map">
          <router-link to="/map">树种分布地图</router-link>
        </el-menu-item>

        <el-sub-menu index="projects" v-if="role_id == 1">
          <template #title><div>项目</div></template>
          <el-menu-item index="projects-1">
            <router-link to="/project/index">项目管理</router-link>
          </el-menu-item>

          <el-menu-item index="projectTypes">
            <router-link to="/project/types">项目类型</router-link>
          </el-menu-item>
          <el-menu-item index="cooperativeUnits">
            <router-link to="/cooperators">合作单位</router-link>
          </el-menu-item>
        </el-sub-menu>

        <el-sub-menu index="surveys">
          <template #title>调查</template>
          <el-menu-item index="surveys">
            <router-link to="/survey/index">调查管理</router-link>
          </el-menu-item>
          <el-menu-item index="places">
            <router-link to="/place/index">点位管理</router-link>
          </el-menu-item>
          <el-menu-item index="places">
            <router-link to="/review/index">评级管理</router-link>
          </el-menu-item>

          <el-menu-item index="pictures">
            <router-link to="/picture/index">照片管理</router-link>
          </el-menu-item>
        </el-sub-menu>

        <el-sub-menu index="categories">
          <template #title>树种</template>
          <el-menu-item index="categories">
            <router-link to="/category/index">树种管理</router-link>
          </el-menu-item>
          <el-menu-item index="landscape">
            <router-link to="/landscape">景观类型</router-link>
          </el-menu-item>
        </el-sub-menu>

        <el-menu-item index="users">
          <router-link to="/user/index">用户</router-link>
        </el-menu-item>
      </el-menu>
    </div>
    <comp-header-user />
  </div>
</template>

<script lang="ts">
export default {
  name: 'DefaultNavbar'
}
</script>

<script lang="ts" setup>
import { inject } from 'vue'
import useUserStore from '../../../stores/user_stores'
import { storeToRefs } from 'pinia'

const userStore = useUserStore()

const { role_id } = storeToRefs(userStore)

const { activeIndex, updateActiveIndex } = inject('menuProps') as any
const handleSelect = (key: string) => {
  updateActiveIndex(key)
}

function goHomePage() {
  let url = 'http://www.sinogaf.cn/'
  window.open(url)
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
.nav {
  display: flex;
  height: 64px;
  background: $header-bg;
  //background-color: #000;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.07);
  width: 100%;
  min-width: 1200px;
  justify-content: flex-start;
  .el-menu-header {
    border-bottom: none;
    align-items: center;
  }
}

.nav-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  margin-left: 40px;
  text-align: center;
  cursor: pointer;
  height: 64px;
  .logo {
    width: auto;
    height: 64px;
    cursor: pointer;
  }
}
.nav-menu {
  flex: 1;
  display: flex;
  border-bottom: 0;

  .el-menu-item.is-active {
    border-width: 3px;
  }

  .el-menu--horizontal > .el-sub-menu .el-sub-menu__title {
    color: #fff;
  }
}
</style>
